<script setup lang="ts">
import getVideoId from 'get-video-id'

const props = defineProps({
    blok: Object,
})

const video = computed(() => {
    return getVideoId(props.blok?.url)
})
</script>

<template>
    <section class="section">
        <UiContainer max-width="max-w-3xl">
            <header class="global-text text-center">
                <StoryblokRichText :doc="blok?.header" />
            </header>
        </UiContainer>
        <UiContainer>
            <div
                v-motion-slide-visible-once-top
                class="mt-20 w-full h-full aspect-video"
            >
                <iframe
                    v-if="video?.id && video?.service === 'youtube'"
                    :src="`https://www.youtube.com/embed/${video.id}`"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen
                    class="w-full h-full"
                />
            </div>
        </UiContainer>
    </section>
</template>
